import React, { useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { Form } from 'react-final-form';
import { Button, ButtonWithLoading } from '../Button';
import DynamicForm from '../form/DynamicForm';
import { FormButtonToolbar, FormContainer } from '../form/FormElements';
import {
  emptySalvarConfiguracaoForm,
  getSalvarConfiguracaoFormStructure,
  salvarConfiguracaoFormSections,
  validateSalvarConfiguracaoForm
} from './salvarConfiguracaoFormConfig';

const SalvarConfiguracaoModal = ({
  show,
  onClose,
  onSalvar,
  loading,
  podeSalvarGeral
}) => {
  const formStructure = useMemo(
    () => getSalvarConfiguracaoFormStructure(podeSalvarGeral),
    [podeSalvarGeral]
  );

  const handleSubmit = async (values) => {
    const nomeNormalizado = String(values?.nome || '').trim();
    if (!nomeNormalizado) {
      return;
    }

    await onSalvar({
      nome: nomeNormalizado,
      geral: podeSalvarGeral ? values.geral === true : false,
      padrao: values.padrao === true
    });
  };

  return (
    <Modal show={show} onHide={onClose} animation={false} centered>
      <Modal.Header closeButton>
        <Modal.Title>Salvar configuracao</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form
          key={show ? 'open' : 'closed'}
          onSubmit={handleSubmit}
          initialValues={emptySalvarConfiguracaoForm}
          validate={validateSalvarConfiguracaoForm}
        >
          {({ handleSubmit: onFormSubmit }) => (
            <FormContainer onSubmit={onFormSubmit}>
              <DynamicForm
                structure={formStructure}
                sections={salvarConfiguracaoFormSections()}
                readOnly={false}
              />

              <FormButtonToolbar className="mt-3">
                <Button variant="secondary" type="button" onClick={onClose} disabled={loading}>
                  Cancelar
                </Button>
                <ButtonWithLoading variant="primary" type="submit" loading={loading} loadingText="Salvando...">
                  Salvar
                </ButtonWithLoading>
              </FormButtonToolbar>
            </FormContainer>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default SalvarConfiguracaoModal;
